import React from 'react'
import parse from 'html-react-parser'
import Layout from '../components/layout'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import ContactSplash from '../../static/img/splash-contactus-2021.jpg'
import DuncanHallImage from '../images/visit-duncan-hall.jpeg'

class ContactPage extends React.Component {
     constructor(props) {
          super(props);
     }


     render() {
          let content = this.props.data.contactPageContent;
          console.log(content);
          return (
               <Layout className="contact-page">
                    <div
                         className="splash jumbotron"
                         style={{ minHeight: '400px', marginBottom: '0px', backgroundImage:`url(${ContactSplash})`, backgroundSize:'cover', backgroundPosition: 'center center' }}
                    >
                         <h1 className="text-white text-center wow fadeInDown">CONTACT</h1>
                    </div>
                    <div className="container-fluid container-timeline">
                         <div className="container pt-4">
                              {/*<div className="row">
                                   <div className="col-md-12 wow fadeInDown">
                                        <h2 className="text-center text-primary mt-4">Duncan Hall</h2>
                                   </div>
                              </div>*/}
                              <div className="row">
                                   <div className="col-xs-12 col-sm-6 col-lg-6 wow fadeInLeft">
                                        <form name="contact" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" className="contact_frm">
                                             <input type="hidden" name="bot-field" />
                                             <input type="hidden" name="form-name" value="contact" />
                                             <div className="form_field form-group">
                                                  <label htmlFor="name">Your Name: </label><br />
                                                  <input type="text" name="name" id="name" className="form-control" required />
                                             </div>
                                             <div className="form_field form-group">
                                                  <label htmlFor="email">Your Email: </label><br />
                                                  <input type="email" name="email" id="email" className="form-control" required />
                                             </div>
                                             <div className="form_field form-group">
                                                  <label htmlFor="message">Message: </label><br />
                                                  <textarea name="message" id="message" className="form-control" rows="5" required></textarea>
                                             </div>
                                             <div className="form_field form-group">
                                                  <button type="submit" className="btn btn-info btn-lg text-center text-basic" >Send</button>
                                             </div>
                                        </form>
                                        <iframe
                                             height="300"
                                             frameBorder="0" style={{ border: 0, width: '100%' }}
                                             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3465.081648397998!2d-95.40401988489255!3d29.717394082002457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c064b7f18e1f%3A0xe2cd9cf065c43eb5!2sRice+University!5e0!3m2!1sen!2sin!4v1562914991425!5m2!1sen!2sin" width="600" allowFullScreen></iframe>
                                   </div>
                                   <div className="col-xs-12 col-sm-6 col-lg-6 wow fadeInRight">
                                   <img src={content.image[0].url} alt="Duncan Hall" />
                                        <div>
                                             {parse(content.description)}
                                        </div>
                                   </div>
                              </div>
                             {/*} <div className="row">
                                   <div className="col-md-12 wow fadeInDown">
                                        <h2 className="text-center text-primary mt-4">Contact</h2>
                                   </div>
                              </div>
                             */}
                         </div>
                    </div>
               </Layout>
          );
     }
}

export default ContactPage;
export const query = graphql`
query ContactPage {
contactPageContent: flamelinkContactContent{
    title,
    description,
    image {
      url
    }
  }
}`;
